import React, { forwardRef } from "react";
import PropTypes from "prop-types";

// @mui material components
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

const MDSelect = forwardRef(
  ({ label, labelDefault, valueDefault, variant, data, ...rest }, ref) => {
    return (
      <FormControl variant={variant} fullWidth>
        <InputLabel>{label}</InputLabel>
        <Select {...rest}>
          <MenuItem value={valueDefault} disabled>
            <em>{labelDefault}</em>
          </MenuItem>
          {data.map((item) => (
            <MenuItem value={item.id} key={item.id}>
              {item.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
);

export default MDSelect;

MDSelect.defaultProps = {
  variant: "standard",
  valueDefault: "",
};

MDSelect.propTypes = {
  label: PropTypes.string.isRequired,
  labelDefault: PropTypes.string.isRequired,
  valueDefault: PropTypes.string,
  variant: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
};
